import { getAllFacilities } from './getAllFacilities';
import { EFacilityType, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

const BATH_TYPES = [EFacilityType.Bath, EFacilityType.Shower];

export function getBathTypes(jsonQuery: TJsonQuery): NonEmptyArray<EFacilityType> | null {
  const facilities = (getAllFacilities(jsonQuery) || []).filter(f => BATH_TYPES.includes(f));

  return nonEmptyArrayOr(facilities);
}
